import React from "react";
import styled from "@emotion/styled";
import { Color } from "../../utils/color";
import { Link } from "gatsby";

import { Breadcrumbs } from "../../components/breadcrumbs/breadcrumbs";
import { EnLayout } from "../../components/layout/enLayout";

const EnCompanyPage = () => {
  return (
    <EnLayout title="COMPANY | LIME" jpUrl="/company/" enUrl="/en/company/">
      <Breadcrumbs>
        <Link to="/en/">HOME</Link>
        <span>/</span>
        <Link to="/en/company/">COMPANY</Link>
        <span>/</span>
      </Breadcrumbs>
      <SSection>
        <p>EN COMPANY</p>
      </SSection>
    </EnLayout>
  );
};

export default EnCompanyPage;

const SSection = styled.section`
  background-color: ${Color.light};
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
